import * as actionTypes from "../constants/actionTypes";
import { Entities, CategoryEntities } from "../interfaces";
import { Action as MarkerActions } from "./markets";

export interface GetFiltersAction {
  type: "GET_FILTERS";
}
export interface GetFiltersSuccessAction {
  type: "GET_FILTERS_SUCCESS";
  payload: {
    typologies: Entities;
    markets: Entities;
    categories: CategoryEntities;
    tags: Entities;
    properties: Entities;
  };
}
export interface GetFiltersErrorAction {
  type: "GET_FILTERS_ERROR";
  payload: { error: string; status: number };
}
export interface SetFiltersAfterAction {
  type: "SET_FILTERS_AFTER_EDIT";
  payload: {
    filters: {
      categories: Array<string>;
      item_types: Array<string>;
      markets: Array<string>;
      properties: Array<string>;
      tags: Array<string>;
    };
  };
}

export type Action =
  | GetFiltersAction
  | GetFiltersSuccessAction
  | GetFiltersErrorAction
  | MarkerActions
  | SetFiltersAfterAction;

export function getFilters(): Action {
  return {
    type: actionTypes.GET_FILTERS
  };
}

export function getFiltersSuccess(
  typologies: Entities,
  markets: Entities,
  categories: CategoryEntities,
  tags: Entities,
  properties: Entities
): Action {
  return {
    type: actionTypes.GET_FILTERS_SUCCESS,
    payload: {
      typologies,
      markets,
      categories,
      tags,
      properties
    }
  };
}

export function getFiltersError(error: string, status: number): Action {
  return {
    type: actionTypes.GET_FILTERS_ERROR,
    payload: {
      error,
      status
    }
  };
}

export function setFiltersAfter(filters: {
  categories: Array<string>;
  item_types: Array<string>;
  markets: Array<string>;
  properties: Array<string>;
  tags: Array<string>;
}): Action {
  return {
    type: actionTypes.SET_FILTERS_AFTER_EDIT,
    payload: {
      filters
    }
  };
}
